// @ts-nocheck
import * as React from "react";

const TagLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M12.998 21.671 3 11.692V3h8.692l9.992 10.004-8.686 8.667Zm0-1.421 7.266-7.265-8.998-8.966H4v7.265l8.998 8.966ZM6.55 7.558c.28 0 .519-.098.715-.292a.962.962 0 0 0 .293-.708.992.992 0 0 0-.292-.722.955.955 0 0 0-.708-.298.987.987 0 0 0-.722.295.971.971 0 0 0-.298.717c0 .28.099.519.295.715a.978.978 0 0 0 .717.293Z"
            />
        </svg>
    );
};

export default React.memo(TagLine);
